<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" dark>
        <v-btn @click="routerBack" icon>
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title
          style="
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin: 0;
            padding: 0;
            max-width: 70%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
          class="text-center"
        >
          {{ childName }}
        </v-toolbar-title>
        <v-btn icon disabled style="visibility: hidden">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>
    </div>

    <div class="px-2 pt-5">
      <v-form id="getTokenForm" ref="post_card_form">
        <div class="mb-2">
          <p class="caption grey--text text--darken-2">カード番号</p>
          <v-text-field
            v-model="cardno"
            :rules="[
              rules.required,
              rules.typeStringNumber,
              rules.counter14to16,
            ]"
            type="number"
            outlined
            dense />
        </div>
        <div class="mb-2">
          <p class="caption grey--text text--darken-2">カード有効期限</p>
          <div class="d-flex justif -center align-center">
            <v-select
              label="年"
              :items="yearOptions()"
              v-model="expireYear"
              :rules="[rules.required]"
              type="number"
              outlined
              dense></v-select>
            <p class="px-3 pb-7">/</p>
            <v-select
              label="月"
              :items="monthOptions()"
              v-model="expireMonth"
              :rules="[rules.required]"
              type="number"
              outlined
              dense></v-select>
          </div>
        </div>
        <div class="mb-2">
          <p class="caption grey--text text--darken-2">カード名義人</p>
          <v-text-field
            v-model="holdername"
            :rules="[rules.required, rules.typeAlphabet]"
            outlined
            dense />
        </div>
        <div class="mb-2">
          <p class="caption grey--text text--darken-2">セキュリティコード</p>
          <v-text-field
            v-model="securitycode"
            :rules="[rules.required, rules.typeStringNumber, rules.counterMin4]"
            outlined
            dense />
        </div>
      </v-form>
    </div>

    <div class="d-flex justify-center mt-5">
      <v-btn
        @click="postPaymentMethodCardRequest"
        :loading="btnLoading"
        color="primary">
        保存する
      </v-btn>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import rules from '@/service/ValidRules';

import { familyModule } from '@/store/entityModules/family';
import { paymentModule } from '@/store/entityModules/payment';
import {
  ERROR_CODE_CARD_3DS_AUTH_FAILED,
  ERROR_CODE_CARD_TOKEN_INVALID,
  getApiErrorCode,
} from '@/api/ApiClient';
import {
  countCardRegisterFailure,
  isCardRegisterLocked,
  resetCardRegisterFailure,
  showCardRegisterLocked,
} from '@/service/CardRegisterLock';

import type { VForm } from 'vuetify/components';
import dayjs from 'dayjs';

interface Window {
  Multipayment?: any;
  gmoPaymentCallback?: any;
}

declare var window: Window;

interface DataType {
  childId: number;
  childName: string;
  fetchLoading: boolean;
  btnLoading: boolean;
  cardno: string;
  expireYear: string;
  expireMonth: string;
  securitycode: string;
  holdername: string;
  tokennumber: string;
}

export default defineComponent({
  data: (): DataType => ({
    childId: NaN,
    childName: '',
    fetchLoading: false,
    btnLoading: false,
    cardno: '',
    expireYear: '',
    expireMonth: '',
    securitycode: '',
    holdername: '',
    tokennumber: '1',
  }),

  computed: {
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).post_card_form;
    },
    family() {
      return familyModule.family;
    },
  },

  methods: {
    yearOptions() {
      const options: string[] = [];
      for (let i = 0; i < 12; i++) {
        const year = dayjs().add(i, 'year').format('YYYY');
        options.push(year);
      }
      return options;
    },
    monthOptions() {
      const options: string[] = [];
      for (let i = 1; i <= 12; i++) {
        options.push(String(i));
      }
      return options;
    },
    routerBack() {
      // this.$router.replace('/payment', () => {});
      this.$router.replace({
        name: 'Payment',
        query: {
          childId: String(this.childId),
          childName: this.childName,
        },
      });
    },
    toDoubleDigits(month: string) {
      if (month.length === 1) {
        return `0${month}`;
      }
      return month;
    },
    async postPaymentMethodCardRequest() {
      // 既にロックされている場合は処理を中断
//      if (isCardRegisterLocked()) {
//        showCardRegisterLocked();
//        return;
//      }

      const { valid } = await this.form.validate();
      if (valid) {
        this.btnLoading = true;

        // 前回の登録が3Dセキュアのチャレンジ画面で離脱していた場合に備えて、
        // 古い認証情報が残っていないかクリアしておく（残っていると
        // 3dSecure.vue が古いaccessPassを参照してしまう）
        sessionStorage.removeItem('accessPass');
        sessionStorage.removeItem('paymentCardTargetChildId');
        sessionStorage.removeItem('paymentCardTargetChildName');
        sessionStorage.removeItem('paymentCardTargetFamilyId');

        const gmoKey = process.env.VUE_APP_GMO_KEY ?? '';
        window.Multipayment.init(gmoKey);
        window.gmoPaymentCallback = this.callback;
        window.Multipayment.getToken(
          {
            cardno: this.cardno,
            expire: `${this.expireYear}${this.toDoubleDigits(this.expireMonth)}`,
            securitycode: this.securitycode,
            holdername: this.holdername,
            tokennumber: this.tokennumber,
          },
          'gmoPaymentCallback',
        );
      }
    },

    async callback(response: any) {
      // コールバック実行時にもロック状態をチェック
      if (isCardRegisterLocked()) {
        showCardRegisterLocked();
        this.btnLoading = false;
        return;
      }

      // 失敗時のカウント・ロック処理を共通化するローカル関数
      const handleFailure = (title = 'カード情報に誤りがあります', text?: string) => {
        countCardRegisterFailure(title, text).then(() => {
          this.btnLoading = false;
        });
      };

      try {
        if (response.resultCode !== '000') {
          handleFailure();
          return;
        }

        const token = response.tokenObject.token[0];
        if (this.family) {
          const familyId = this.family.familyId;

          // 3Dセキュアのチャレンジ認証画面へ遷移する可能性があるため、
          // 戻り先ページ(3dSecure.vue)で使う情報を事前に保存しておく。
          // GMOのACS認証はフルページ遷移(location.href)のためVuexのstateは
          // リセットされるので、familyIdもここでsessionStorageに退避する。
          sessionStorage.setItem('paymentCardTargetChildId', String(this.childId));
          sessionStorage.setItem('paymentCardTargetChildName', this.childName);
          sessionStorage.setItem('paymentCardTargetFamilyId', String(familyId));

          const postResponse = await paymentModule.postPaymentCardMethod({
            familyId,
            token,
          });

          // 3Dセキュアのチャレンジ認証が必要な場合、Vuexアクション内で
          // すでにカード会社の認証画面へリダイレクトされている。
          // ここでは成功ダイアログを出さずに処理を抜ける。
          if (postResponse && 'requires3ds' in postResponse && postResponse.requires3ds) {
            return;
          }

          // 3Dセキュア不要で完了した場合、遷移情報は不要なので削除
          sessionStorage.removeItem('paymentCardTargetChildId');
          sessionStorage.removeItem('paymentCardTargetChildName');
          sessionStorage.removeItem('paymentCardTargetFamilyId');

          if (postResponse) {
            // 保存成功したらリトライカウントをクッキーから削除
            resetCardRegisterFailure();

            Swal.fire({
              icon: 'success',
              title: 'カードの登録が完了しました',
              padding: '1rem 0',
            }).then((r) => {
              this.routerBack();
            });
            this.btnLoading = false;
          } else {
            handleFailure();
          }
        }
      } catch (e: any) {
        // ここに来る場合はpostPaymentCardMethod内でリダイレクトは発生していないため、
        // 事前に保存しておいた画面遷移用の情報は不要になる
        sessionStorage.removeItem('paymentCardTargetChildId');
        sessionStorage.removeItem('paymentCardTargetChildName');
        sessionStorage.removeItem('paymentCardTargetFamilyId');

        // GMOのカードトークンはワンタイム・短時間で失効する仕様のため、
        // トークン起因のエラーはユーザーの入力ミスとしてカウントせず、
        // そのまま再試行を促す（3回失敗ロックの対象にしない）
        // (APIはエラーコードのみを返すため、メッセージではなくエラーコードで判定する)
        if (getApiErrorCode(e) === ERROR_CODE_CARD_TOKEN_INVALID) {
          Swal.fire({
            icon: 'error',
            title: 'カード情報の送信がタイムアウトしました',
            text: 'お手数ですが、もう一度「保存する」を押してください。',
          }).then(() => {
            this.btnLoading = false;
          });
          return;
        }

        // 3Dセキュアの本人認証失敗・カード会社の拒否も失敗としてカウントする
        if (getApiErrorCode(e) === ERROR_CODE_CARD_3DS_AUTH_FAILED) {
          handleFailure(
            '本人認証に失敗しました',
            'カード会社の本人認証（3Dセキュア）が完了しなかったため、カードは登録されていません。',
          );
          return;
        }
        handleFailure();
      }
    },
  },

  async mounted() {
    const gmoPayment = document.createElement('script');
    // gmoPayment.setAttribute('src', 'https://static.mul-pay.jp/ext/js/token.js')
    const gmoSrc = process.env.VUE_APP_GMO_SRC ?? '';
    gmoPayment.setAttribute('src', gmoSrc);
    // gmoPayment.setAttribute('src', 'https://p01.mul-pay.jp/ext/js/token.js')
    document.head.appendChild(gmoPayment);
    if (typeof this.$route.query.childName === 'string') {
      this.childName = this.$route.query.childName;
    }
    if (typeof this.$route.query.childId === 'number') {
      this.childId = this.$route.query.childId;
      // this.fetchGrowth();
    } else if (typeof this.$route.query.childId === 'string') {
      this.childId = Number(this.$route.query.childId);
      // this.fetchGrowth();
    } else {
      this.routerBack();
    }

    if (!this.family) {
      this.routerBack();
    }
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(env(safe-area-inset-top));
}
</style>
